var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0,
      mixBlendMode: "passthrough"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,3.89474C2,4.94117,4.68629,5.78947,8,5.78947C11.31371,5.78947,14,4.94117,14,3.89474C14,2.848303,11.31371,2,8,2C4.68629,2,2,2.848303,2,3.89474ZM2.318948,5.45517C3.1242099999999997,6.20043,5.363160000000001,6.73727,8,6.73727C10.63684,6.73727,12.8758,6.20043,13.6811,5.45517C13.8042,5.34148,14,5.42359,14,5.59096L14,8.00043C14,9.04569,11.31263,9.89517,8,9.89517C4.68737,9.89517,2,9.04569,2,8.00043L2,5.59096C1.999840698,5.515359999999999,2.0449284,5.447,2.114485,5.41739C2.184041,5.387779999999999,2.264565,5.4026499999999995,2.318948,5.45517ZM8,10.84176C5.363160000000001,10.84176,3.1242099999999997,10.30492,2.318948,9.559660000000001C2.264565,9.50715,2.184041,9.492270000000001,2.114485,9.52188C2.0449289,9.551490000000001,1.999840843,9.61985,2,9.695450000000001L2,12.1049C2,13.1502,4.68737,13.9997,8,13.9997C11.31263,13.9997,14,13.1502,14,12.1049L14,9.695450000000001C14,9.52808,13.8042,9.445979999999999,13.6811,9.559660000000001C12.8758,10.30492,10.63684,10.84176,8,10.84176Z",
    fillRule: "evenodd",
    fill: "#D15DFF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRIcon3);
export default __webpack_public_path__ + "static/media/home_r_icon3.c9d69f46aefba703e05f5e84aef7f718.svg";
export { ForwardRef as ReactComponent };